import { AuthActionTypes } from "./actionTypes";
import { ActionCreator, Action } from "../../../actions/actions";

export const AuthActionCreators: { [key: string]: ActionCreator } = {
    login: (credentials): Action => ({
        type: AuthActionTypes.LOGIN,
        payload: credentials
    }),

    login_success: (token): Action => ({
        type: AuthActionTypes.LOGIN_SUCCESS,
        payload: token
    }),

    login_fail: (error: any) => ({
        type: AuthActionTypes.LOGIN_FAIL,
        payload: error
    }),

    signup: (newUserData): Action => ({
        type: AuthActionTypes.SIGNUP,
        payload: newUserData
    }),

    signup_success: (data): Action => ({
        type: AuthActionTypes.SIGNUP_SUCCESS,
        payload: data
    }),

    signup_fail: (error: any) => ({
        type: AuthActionTypes.SIGNUP_FAIL,
        payload: error
    }),

    recover: (data): Action => ({
        type: AuthActionTypes.RECOVER,
        payload: data
    }),

    recover_success: (data): Action => ({
        type: AuthActionTypes.RECOVER_SUCCESS,
        payload: data
    }),

    recover_fail: (error: any) => ({
        type: AuthActionTypes.RECOVER_FAIL,
        payload: error
    }),

    new_password: (data): Action => ({
        type: AuthActionTypes.NEW_PASSWORD,
        payload: data
    }),

    new_password_success: (data): Action => ({
        type: AuthActionTypes.NEW_PASSWORD_SUCCESS,
        payload: data
    }),

    new_password_fail: (error: any) => ({
        type: AuthActionTypes.NEW_PASSWORD_FAIL,
        payload: error
    }),

    clear_redirect: () => ({
        type: AuthActionTypes.RESET_REDIRECT
    }),

    change_user_status: (data): Action => ({
        type: AuthActionTypes.CHANGE_USER_STATUS,
        payload: data
    }),

    getUsers: search_json => ({
        type: AuthActionTypes.GET_USERS_LIST,
        payload: search_json
    }),

    getUsersPrivileges: () => ({
        type: AuthActionTypes.GET_USERS_PRIVILEGES
    }),

    createUser: user_info_json => ({
        type: AuthActionTypes.CREATE_USER,
        payload: user_info_json
    }),

    editUser: user_info_json => ({
        type: AuthActionTypes.EDIT_USER,
        payload: user_info_json
    }),

    getRoles: search_json => ({
        type: AuthActionTypes.GET_ROLES_LIST,
        payload: search_json
    }),

    createRole: role_info_json => ({
        type: AuthActionTypes.CREATE_ROLE,
        payload: role_info_json
    }),

    deleteRole: role_id => ({
        type: AuthActionTypes.DELETE_ROLE,
        payload: role_id
    }),

    editRole: role_info_json => ({
        type: AuthActionTypes.EDIT_ROLE,
        payload: role_info_json
    }),


    getSubsidiaries: () => ({
        type: AuthActionTypes.GET_SUBSIDIARIES
    }),

    openDrawerRole: () => ({
        type: AuthActionTypes.OPEN_DRAWER
    }),

    getResourceEntity: () => ({
        type: AuthActionTypes.GET_RESOURCE_ENTITY
    }),
};
